/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DodRequest } from "../models/dod-request";
import { DodExportStatus } from "../models/dod-export-status";
import { DodJobEx } from "../models/dod-job-ex";
import { DodBatchLayoutEx } from "../models/dod-batch-layout-ex";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { EditDodRecurringRequest } from "../models/edit-dod-recurring-request";
import { DodEndPointEx } from "../models/dod-end-point-ex";
import { FilterType } from "../models/filter-type";
@Injectable({
  providedIn: "root",
})
class DataOnDemandService extends __BaseService {
  static readonly dataOnDemandExportOnDemandPath =
    "/api/DataOnDemand/DataOnDemand";
  static readonly dataOnDemandGetLatestLayoutJobStatusPath =
    "/api/DataOnDemand/GetLatestLayoutJobStatus";
  static readonly dataOnDemandGetLatestDataOnDemandJobsPath =
    "/api/DataOnDemand/GetLatestDataOnDemandJobs";
  static readonly dataOnDemandGetPrintOnDemandStatusPath =
    "/api/DataOnDemand/GetDataOnDemandStatus/{dataOnDemandId}";
  static readonly dataOnDemandCreateDataOnDemandBatchLayoutPath =
    "/api/DataOnDemand/CreateDataOnDemandBatchLayout";
  static readonly dataOnDemandUpdateDataOnDemandBatchLayoutPath =
    "/api/DataOnDemand/UpdateDataOnDemandBatchLayout/{dataOnDemandBatchLayoutId}";
  static readonly dataOnDemandDeleteDataOnDemandBatchLayoutPath =
    "/api/DataOnDemand/DeleteDataOnDemandBatchLayout/{dataOnDemandBatchLayoutId}";
  static readonly dataOnDemandUpdateDodBatchLayoutSharingPath =
    "/api/DataOnDemand/UpdateDodBatchLayoutSharing";
  static readonly dataOnDemandCreateRecurringDodPath =
    "/api/DataOnDemand/CreateRecurringDod";
  static readonly dataOnDemandUpdateRecurringDodPath =
    "/api/DataOnDemand/UpdateRecurringDod/{dodRecurringId}";
  static readonly dataOnDemandDeleteRecurringDodPath =
    "/api/DataOnDemand/DeleteRecurringDod/{dodRecurringId}";
  static readonly dataOnDemandExecuteRecurringDodNowPath =
    "/api/DataOnDemand/ExecuteRecurringDodNow/{dodRecurringId}";
  static readonly dataOnDemandGetUserAvailableDodEndPointsPath =
    "/api/DataOnDemand/GetUserAvailableDodEndPoints";
  static readonly dataOnDemandGetUserAvailableDodLayoutsPath =
    "/api/DataOnDemand/GetUserAvailableDodLayouts";
  static readonly dataOnDemandGetAllDodEndPointsPath =
    "/api/DataOnDemand/GetAllDodEndPoints";
  static readonly dataOnDemandGetAllDodFilterTypesPath =
    "/api/DataOnDemand/GetAllDodFilterTypes";
  static readonly dataOnDemandClearAllUserCachePath =
    "/api/DataOnDemand/ClearAllUserCache";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param dodRequest undefined
   */
  dataOnDemandExportOnDemandResponse(
    dodRequest: DodRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dodRequest;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/DataOnDemand`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param dodRequest undefined
   */
  dataOnDemandExportOnDemand(dodRequest: DodRequest): __Observable<number> {
    return this.dataOnDemandExportOnDemandResponse(dodRequest).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dodBatchLayoutIds undefined
   */
  dataOnDemandGetLatestLayoutJobStatusResponse(
    dodBatchLayoutIds?: null | Array<number>
  ): __Observable<__StrictHttpResponse<Array<DodExportStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (dodBatchLayoutIds || []).forEach((val) => {
      if (val != null)
        __params = __params.append("dodBatchLayoutIds", val.toString());
    });
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetLatestLayoutJobStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodExportStatus>>;
      })
    );
  }
  /**
   * @param dodBatchLayoutIds undefined
   */
  dataOnDemandGetLatestLayoutJobStatus(
    dodBatchLayoutIds?: null | Array<number>
  ): __Observable<Array<DodExportStatus>> {
    return this.dataOnDemandGetLatestLayoutJobStatusResponse(
      dodBatchLayoutIds
    ).pipe(__map((_r) => _r.body as Array<DodExportStatus>));
  }
  dataOnDemandGetLatestDataOnDemandJobsResponse(): __Observable<
    __StrictHttpResponse<Array<DodJobEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetLatestDataOnDemandJobs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodJobEx>>;
      })
    );
  }
  dataOnDemandGetLatestDataOnDemandJobs(): __Observable<Array<DodJobEx>> {
    return this.dataOnDemandGetLatestDataOnDemandJobsResponse().pipe(
      __map((_r) => _r.body as Array<DodJobEx>)
    );
  }

  /**
   * @param dataOnDemandId undefined
   */
  dataOnDemandGetPrintOnDemandStatusResponse(
    dataOnDemandId: number
  ): __Observable<__StrictHttpResponse<DodJobEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/DataOnDemand/GetDataOnDemandStatus/${dataOnDemandId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodJobEx>;
      })
    );
  }
  /**
   * @param dataOnDemandId undefined
   */
  dataOnDemandGetPrintOnDemandStatus(
    dataOnDemandId: number
  ): __Observable<DodJobEx> {
    return this.dataOnDemandGetPrintOnDemandStatusResponse(dataOnDemandId).pipe(
      __map((_r) => _r.body as DodJobEx)
    );
  }

  /**
   * @param request undefined
   */
  dataOnDemandCreateDataOnDemandBatchLayoutResponse(
    request: DodBatchLayoutEx
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/CreateDataOnDemandBatchLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  dataOnDemandCreateDataOnDemandBatchLayout(
    request: DodBatchLayoutEx
  ): __Observable<number> {
    return this.dataOnDemandCreateDataOnDemandBatchLayoutResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDataOnDemandBatchLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dataOnDemandBatchLayoutId`:
   */
  dataOnDemandUpdateDataOnDemandBatchLayoutResponse(
    params: DataOnDemandService.DataOnDemandUpdateDataOnDemandBatchLayoutParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/UpdateDataOnDemandBatchLayout/${params.dataOnDemandBatchLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDataOnDemandBatchLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dataOnDemandBatchLayoutId`:
   */
  dataOnDemandUpdateDataOnDemandBatchLayout(
    params: DataOnDemandService.DataOnDemandUpdateDataOnDemandBatchLayoutParams
  ): __Observable<number> {
    return this.dataOnDemandUpdateDataOnDemandBatchLayoutResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dataOnDemandBatchLayoutId undefined
   */
  dataOnDemandDeleteDataOnDemandBatchLayoutResponse(
    dataOnDemandBatchLayoutId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/DeleteDataOnDemandBatchLayout/${dataOnDemandBatchLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dataOnDemandBatchLayoutId undefined
   */
  dataOnDemandDeleteDataOnDemandBatchLayout(
    dataOnDemandBatchLayoutId: number
  ): __Observable<Blob> {
    return this.dataOnDemandDeleteDataOnDemandBatchLayoutResponse(
      dataOnDemandBatchLayoutId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDodBatchLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `dodBatchLayoutId`:
   */
  dataOnDemandUpdateDodBatchLayoutSharingResponse(
    params: DataOnDemandService.DataOnDemandUpdateDodBatchLayoutSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.dodBatchLayoutId != null)
      __params = __params.set(
        "dodBatchLayoutId",
        params.dodBatchLayoutId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/UpdateDodBatchLayoutSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDodBatchLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `dodBatchLayoutId`:
   */
  dataOnDemandUpdateDodBatchLayoutSharing(
    params: DataOnDemandService.DataOnDemandUpdateDodBatchLayoutSharingParams
  ): __Observable<boolean> {
    return this.dataOnDemandUpdateDodBatchLayoutSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param request undefined
   */
  dataOnDemandCreateRecurringDodResponse(
    request: EditDodRecurringRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/CreateRecurringDod`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  dataOnDemandCreateRecurringDod(
    request: EditDodRecurringRequest
  ): __Observable<number> {
    return this.dataOnDemandCreateRecurringDodResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateRecurringDodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dodRecurringId`:
   */
  dataOnDemandUpdateRecurringDodResponse(
    params: DataOnDemandService.DataOnDemandUpdateRecurringDodParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/UpdateRecurringDod/${params.dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateRecurringDodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dodRecurringId`:
   */
  dataOnDemandUpdateRecurringDod(
    params: DataOnDemandService.DataOnDemandUpdateRecurringDodParams
  ): __Observable<number> {
    return this.dataOnDemandUpdateRecurringDodResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandDeleteRecurringDodResponse(
    dodRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/DeleteRecurringDod/${dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandDeleteRecurringDod(dodRecurringId: number): __Observable<Blob> {
    return this.dataOnDemandDeleteRecurringDodResponse(dodRecurringId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandExecuteRecurringDodNowResponse(
    dodRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/ExecuteRecurringDodNow/${dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandExecuteRecurringDodNow(
    dodRecurringId: number
  ): __Observable<Blob> {
    return this.dataOnDemandExecuteRecurringDodNowResponse(dodRecurringId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  dataOnDemandGetUserAvailableDodEndPointsResponse(): __Observable<
    __StrictHttpResponse<Array<DodEndPointEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetUserAvailableDodEndPoints`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodEndPointEx>>;
      })
    );
  }
  dataOnDemandGetUserAvailableDodEndPoints(): __Observable<
    Array<DodEndPointEx>
  > {
    return this.dataOnDemandGetUserAvailableDodEndPointsResponse().pipe(
      __map((_r) => _r.body as Array<DodEndPointEx>)
    );
  }
  dataOnDemandGetUserAvailableDodLayoutsResponse(): __Observable<
    __StrictHttpResponse<Array<DodBatchLayoutEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetUserAvailableDodLayouts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodBatchLayoutEx>>;
      })
    );
  }
  dataOnDemandGetUserAvailableDodLayouts(): __Observable<
    Array<DodBatchLayoutEx>
  > {
    return this.dataOnDemandGetUserAvailableDodLayoutsResponse().pipe(
      __map((_r) => _r.body as Array<DodBatchLayoutEx>)
    );
  }
  dataOnDemandGetAllDodEndPointsResponse(): __Observable<
    __StrictHttpResponse<Array<DodEndPointEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetAllDodEndPoints`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodEndPointEx>>;
      })
    );
  }
  dataOnDemandGetAllDodEndPoints(): __Observable<Array<DodEndPointEx>> {
    return this.dataOnDemandGetAllDodEndPointsResponse().pipe(
      __map((_r) => _r.body as Array<DodEndPointEx>)
    );
  }
  dataOnDemandGetAllDodFilterTypesResponse(): __Observable<
    __StrictHttpResponse<Array<FilterType>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetAllDodFilterTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FilterType>>;
      })
    );
  }
  dataOnDemandGetAllDodFilterTypes(): __Observable<Array<FilterType>> {
    return this.dataOnDemandGetAllDodFilterTypesResponse().pipe(
      __map((_r) => _r.body as Array<FilterType>)
    );
  }
  dataOnDemandClearAllUserCacheResponse(): __Observable<
    __StrictHttpResponse<Blob>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/ClearAllUserCache`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  dataOnDemandClearAllUserCache(): __Observable<Blob> {
    return this.dataOnDemandClearAllUserCacheResponse().pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module DataOnDemandService {
  /**
   * Parameters for DataOnDemandUpdateDataOnDemandBatchLayout
   */
  export interface DataOnDemandUpdateDataOnDemandBatchLayoutParams {
    request: DodBatchLayoutEx;
    dataOnDemandBatchLayoutId: number;
  }

  /**
   * Parameters for DataOnDemandUpdateDodBatchLayoutSharing
   */
  export interface DataOnDemandUpdateDodBatchLayoutSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    dodBatchLayoutId?: number;
  }

  /**
   * Parameters for DataOnDemandUpdateRecurringDod
   */
  export interface DataOnDemandUpdateRecurringDodParams {
    request: EditDodRecurringRequest;
    dodRecurringId: number;
  }
}

export { DataOnDemandService };
